import React, { FC } from 'react';

import { Outlet, useLocation } from 'react-router-dom';

import { PublicPageLayout } from '@adsk/alloy-project-page-layout';

import ACCLaunchDarklyOptionalSubscriber from './ACCLaunchDarklyOptionalSubscriber';
import { ConnectedAnnouncementBanner } from './AnnouncementBanner/ConnectedAnnouncementBanner';
import { OptionalUserListener } from './Authnentication/OptionalUserListener';
import { PageNotFoundRedirect } from './PageNotFoundRedirect/PageNotFoundRedirect';
import { PublicRoute } from '../envs/types';
import getCurrentRoute from '../utils/getCurrentRoute';

const RootPublicPageLayout: FC = () => {
  const location = useLocation();
  const currentRoute = getCurrentRoute<PublicRoute>(location);

  if (!currentRoute) {
    return <PageNotFoundRedirect />;
  }
  const { layoutProps } = currentRoute;

  return (
    <PublicPageLayout
      {...layoutProps}
      renderAboveLayout={() => <ConnectedAnnouncementBanner />}
    >
      <OptionalUserListener />
      <ACCLaunchDarklyOptionalSubscriber />
      <Outlet />
    </PublicPageLayout>
  );
};

export default RootPublicPageLayout;
